import { React, useEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import Swiper from "swiper";
import "swiper/css";
import "./marquee.css"; // add CSS file
import CardComp from "./CardComp";
import uiux from '../images/uiux.png'
import digitalMarketing from '../images/digital.png'
import seoImage from '../images/seo.png'
import webDesign from '../images/webDesign.png'
import appDesign from '../images/app.png'
import softwereImage from '../images/softwereImage.png'
import videoImage from '../images/videoImage.png'
import Advertisement from '../images/ad.png'
import googleAds from '../images/googleAds.png'
import productDesign from '../images/productDesign.png'
import socialMedia from '../images/socialMedia.png'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const MarqueeEffect = () => {
  useEffect(() => {
    ScrollTrigger.refresh();
    ScrollTrigger.config({
      autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize",
    });

    // Smooth Scroll
    const smoother = ScrollSmoother.create({
      wrapper: "#smooth-wrapper",
      content: "#smooth-content",
      smooth: 2,
      smoothTouch: false,
      normalizeScroll: true,
      ignoreMobileResize: true,
      effects: true,
      preventDefault: true,
    });

    // Marquee Effect
    const marquee = document.querySelectorAll(".marquee");

    marquee.forEach((section) => {
      const carousels = section.querySelectorAll(".marquee-carousel");

      carousels.forEach((carousel) => {
        const items = carousel.querySelector(".marquee-items");
        const item = carousel.querySelectorAll(".marquee-item");

        carousel.classList.add("swiper-container");
        items.classList.add("swiper-wrapper");
        item.forEach((i) => i.classList.add("swiper-slide"));

        new Swiper(carousel, {
          slidesPerView: "auto",
          loop: true,
          freeMode: true,
          freeModeMomentumBounce: false,
          freeModeMomentumVelocityRatio: 0.3,
        });
      });

      // GSAP Scroll Animation
      const tl = gsap.timeline();
      tl.set(carousels, { willChange: "transform" });

      tl.fromTo(
        carousels[0],
        { x: -300 },
        { x: 0, ease: "none" },
        0
      );

      tl.fromTo(
        carousels[1],
        { x: 300 },
        { x: 0, ease: "none" },
        0
      );

      ScrollTrigger.create({
        trigger: section,
        animation: tl,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.3,
        refreshPriority: -14,
      });
    });
  }, []);

  const cardData = [
    {
      "id": "1",
      "title": "Designing",
      "subtitle": "Creative UI/UX & layouts",
      "image": uiux,
      "description": "Creative UI/UX, stunning layouts, and visually engaging designs crafted to elevate brand identity."
    },
    {
      "id": "2",
      "title": "Digital Marketing",
      "subtitle": "Growth & analytics",
      "image": digitalMarketing,
      "description": "End-to-end digital growth strategies, including social campaigns, analytics, and conversion optimization."
    },
    {
      "id": "3",
      "title": "SEO Analysis",
      "subtitle": "Keyword + competitor insights",
      "image": seoImage,
      "description": "Deep keyword research, competitor insights, and on-page/off-page optimization to boost organic visibility."
    },
    {
      "id": "4",
      "title": "Website Designing",
      "subtitle": "Responsive, modern sites",
      "image": webDesign,
      "description": "High-performance, responsive, and modern websites that deliver great user experience across all devices."
    },
    {
      "id": "5",
      "title": "Application Design",
      "subtitle": "Mobile & web UX",
      "image": appDesign,
      "description": "Intuitive mobile & web app interfaces focused on usability, accessibility, and user-centric workflows."
    },
    {
      "id": "6",
      "title": "Software Design",
      "subtitle": "Architecture & wireframes",
      "image": softwereImage,
      "description": "Custom software wireframes, logical architecture planning, and scalable workflow design solutions."
    },
  ];

  const card2Data = [
    {
      "id": "7",
      "title": "Video Marketing",
      "subtitle": "Promotional & ad videos",
      "image":videoImage,
      "description": "Engaging promotional content, brand stories, reels, and ad videos to maximize audience attention."
    },
    {
      "id": "8",
      "title": "Advertisement",
      "subtitle": "High-impact creatives",
      "image":Advertisement,
      "description": "High-impact ad creatives and targeted campaigns designed to increase brand awareness and conversions."
    },
    {
      "id": "9",
      "title": "Google & Meta Ads",
      "subtitle": "Paid campaigns & leads",
      "image": googleAds,
      "description": "Precise targeting, budget optimization, and performance tracking to generate quick and quality leads."
    },
    {
      "id": "10",
      "title": "Product Design",
      "subtitle": "Prototypes & visuals",
      "image": productDesign,
      "description": "User-focused product concepts, prototypes, and visual models crafted to make your product stand out."
    },
    {
      "id": "11",
      "title": "Social Media Handling",
      "subtitle": "Content & engagement",
      "image":socialMedia,
      "description": "Complete management including content creation, scheduling, analytics, and audience engagement."
    }
  ];

  return (
    <>
      <div className={`vision-heading visible`}>
        <h1>Our Services </h1>
        <div className="heading-underline" />
      </div>

      <section className="marquee">
        <div className="marquee-carousel marquee-carousel-1">
          <div className="marquee-items">
            {Array.from({ length: 10 }).map((_, i) => (
              <div className="marquee-item" key={i}>
                <CardComp data={cardData[i % cardData.length]} />
              </div>
            ))}
          </div>
        </div>

        <div className="marquee-carousel marquee-carousel-2">
          <div className="marquee-items">
            {Array.from({ length: 10 }).map((_, i) => (
              <div className="marquee-item" key={i}>
                <CardComp data={card2Data[i % card2Data.length]} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MarqueeEffect;
